import axios from "axios";

var baseURL = "";
var apiToken = "";

export const CondolenceApi = {
  setApiCredentials: function (token) {
    baseURL = "https://condoleance-api.jollyhill-1f167cf7.westeurope.azurecontainerapps.io/api/v2";
    apiToken = token;
  },

  getAllByFuneralHome: async function (
    page = 1,
    pageSize = 9,
    filter = undefined,
    funeralHomeFilter = undefined
  ) {
    var condolenceApi = axios.create({
      withCredentials: false,
      baseURL: baseURL,
      headers: {
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const response = await condolenceApi.request({
      url: "/dossier/search",
      method: "POST",
      params: { page: page },
      data: {
        AMOUNT_PER_PAGE: pageSize,
        SEARCH_FILTER: filter,
        YEAR_OF_BIRTH: undefined,
        YEAR_OF_DEATH: undefined,
        FUNERALHOME_ID: funeralHomeFilter,
        PLACE_OF_BIRTH: [],
        PLACE_OF_DEATH: [],
      },
    });
    return response.data;
  },
};
